module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-img-box",
    style: ({
      backgroundImage: 'url(' + _vm.content + ')',
      backgroundSize: _vm.backgroundsize,
      backgroundRepeat: _vm.backgroundrepeat,
      backgroundPosition: _vm.backgroundposition
    })
  }, [_c('div', {
    staticClass: "overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4daa7509","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-img-box/block-img-box.pug
// module id = 645
// module chunks = 1